import { useEffect } from 'react';

export function useSkipLink(roomId: string, doc: Document = document) {
  useEffect(() => {
    if (!roomId) return;
    /**
     * General case, use skipLink class
     * Older CMS, DIGITAL_INSCHOOL_SAT, use hard-coded 'attendance-step-6-skipLink'
     * Added multiple skipLink elements functionality
     */

    const elements = [
      ...Array.from(doc.getElementsByClassName(`skipLink`) || []),
      ...Array.from(doc.getElementsByClassName('attendance-step-6-skipLink') || []),
    ];
    if (elements.length > 0) {
      elements.forEach((el: Element) => {
        const hrefFirstPartForRoomId = `/rooms/get/${roomId}`;
        if (!(el as HTMLAnchorElement).pathname.startsWith(hrefFirstPartForRoomId)) {
          (el as HTMLAnchorElement).href = `${hrefFirstPartForRoomId}${(el as HTMLAnchorElement).pathname}`;
        }
      });
    }
  });
}
